import gql from 'graphql-tag';

export default gql`
    query getMultipartSignedUrls($bucketKey: String!, $uploadId: String!, $parts: [Int]!, $organisationId: String!) {
        getMultipartSignedUrls(bucketKey: $bucketKey, uploadId: $uploadId, parts: $parts, organisationId: $organisationId) {
            partNumber
            url
        }
    }
`;